
export class FileUploadHelper {
  /**
   * convert object to FormData
   *
   * @param data any object
   *
   * @return FormData
   */
  public static toFormData(data: object): FormData {
    const formData: FormData = new FormData();

    for (const formItem in data) {
      if (data.hasOwnProperty(formItem) && data[formItem] !== null) {
        formData.append(formItem, data[formItem]);
      }
    }
    return formData;
  }

  /**
   * open file in new tab
   *
   * @param data the file content in arrayBuffer format
   * @param filename download file name
   *
   * @return `void`
   */
  static openFile(data: ArrayBuffer | string | File, filename: string): void {
    // Use the URL object to create a temporary URL
    let url = data as string;

    if (data instanceof ArrayBuffer) {
      url = window.URL.createObjectURL(new Blob([data]));
    }
    const link = document.createElement('a');
    link.download = filename;
    link.target = '_blank';
    link.href = url;
    link.click();
  }

  /**
   * convert File object to base64
   *
   * @param file the File object
   *
   * @return Promise with base64
   */
  static FileToBase64(file: File): Promise<string> {
    return new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result.toString());
      fileReader.readAsDataURL(file);
    });
  }

  /**
   * convert Base64 object to Blob
   *
   * @param file the Base64 file
   * @param type the file type
   *
   * @return Blob with Blob
   */
  static base64ToBlob(file: string, type: string = 'application/pdf'): Blob {
    const binary = atob(file.split(',')[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {type});
  }

  /**
   * checks file extension
   *
   * @param allowedTypes allowed types array
   * @param type the file type
   *
   * @return boolean
   */
  static checkExtension(type: string, allowedTypes: string[]): boolean {
    const extensionName = type.split('/').pop();
    const extension = `.${extensionName}`;
    return allowedTypes.includes(extension);
  }

}

